// Main configuration and initializations

(function(pes, $) {
  // NOTE: pes is an alias of the PESAPP global module

  // Declare components that have the same configurations so you won't
  // have to repeat yourself

  var sponsorConfig = {
    // Feed URL from sponsortool.penton.com
    // * Add it here so you won't need to repeat it
    url: 'https://sponsortool.penton.com/json/1570727',
    options: {
      // Sort by level, then title
      sorts: 'field_logo_sponsor_level,title'
    }
  };

  var sponsorLevel = {
    // Levels by number with custom headings
    '1': {
      heading: 'Platinum',
      columnClass: 'col-sm-6',
      sizeClass: 'platinum'
    },
    '2': {
      heading: 'Gold',
      columnClass: 'col-sm-6 col-lg-4',
      sizeClass: 'gold'
    },
    '3': {
      heading: 'Silver',
      columnClass: 'col-xs-6 col-sm-4 col-lg-3',
      sizeClass: 'silver'
    },
    '4': {
      heading: 'Marketing Partner',
      columnClass: 'col-xs-6 col-sm-4 col-lg-3',
      sizeClass: 'silver'
    }
  };

  // use pes.extend()

  var sponsors = pes.extend(pes.sponsor, sponsorConfig);
  sponsors = pes.extend(sponsors, {
    options: sponsorLevel
  });
  var sponsorIndex = pes.extend(pes.sponsorIndex, sponsorConfig);
  sponsorIndex = pes.extend(sponsorIndex, {
    levels: sponsorLevel
  });

  // sponsors and sponsorIndex can be initialized inside
  // $(document).ready(function() {...}) below with additional
  // configurations added; like this:
  //  * pes.extend(sponsors, { <config object> }).init();
  // or initialize it as is, like this:
  //  * sponsors.init();

  // Initialize components, one initialization per view element
  // use pes.extend().init()

  $(document).ready(function() {


    // Sponsor carousel
    pes.extend(sponsors, {
        view: '#sponsor-carousel',
        options: {
          // sorts: 'randomize' with levels defined will randomize sponsors
          // within each level group, otherwise 'randomize' with levels: false
          // will be completly random
          sorts: 'randomize',
          // Only displays Level 1 and 2 sponsors
          // levels: '1,2',
          // How many logos are displayed per slide
          // logosPerSlide: 3,
          // The dispaly size of each logo in the carousel
          // sizeClass: 'gold',
          // Most components include a default template. However, you can add or
          // override a template a few ways.
          // Override a template:
          // 1) As an HTML attribute on the view element: data-template="some-template"
          // 2) As below
          // * NOTE: Both ways also support jQuery selectors
          template: 'base-sponsor-carousel'
          // Templates also support jQuery selectors, so '#mytpl-sponsor-carousel'
          // (note the '#' selector)would correspond to a an element on the page, like this:
          // <script id="mytpl-sponsor-carousel" type="text/x-handlebars-template"> <your html> </script>
        }
      }
    ).init();

    // Sponsor list
    pes.extend(sponsors, {
        view: '#sponsor-list',
        options: {
          // Define the template
          template: 'base-sponsor-list-cards',
          // Alter the sort
          // sorts: 'field_logo_opportunity,title',
          toggleAll: '#sponsor-list-toggle'
        }
      }
    ).init();

    // Sponsor index
    pes.extend(sponsorIndex, {
      view: '#sponsor-index',
    }).init();

    // Attendee list
    pes.extend(pes.attendee, {
        // Feed URL from inMotion hosting for the attendee list
        // * Add an eventID parameter (that corresponds to the id in eTouches)
        // * By default, this returns company, jobTitle and  country
        //   ... &select=firstName,lastName,fullName,company,jobTitle,photoUrl
        // * NOTE: When you add fields you'll need to build a new template to
        //   display them
        // * NOTE: This resource caches, so if you update the select parameter,
        //   you will need to add &clear_cache=1 to update the cache instantly
        url: '//pentonweb.com/api/v2/etouches/getAttendeeList.php?id=189090',
        view: '#attendee-list',
        controller: '#attendee-list-controller',
        options: {
          // If you want to hide the list until items reach this number
          // displayAt: 50,
          // How to sort the initial view
          sorts: 'lastName,firstName,company',
          controllers: {
            keyword: {
              // Which fields to match the keyword search against
              filters: 'fullName,company,jobTitle'
            }
          }
        }
      }
    ).init();

    // Carousel
    pes.extend(pes.carousel, {
      view: '.pes-carousel',
      options: {
        // Default options shown below
        controls: {
          show: true,
          template: 'base-carousel-controls'
        },
        indicators: {
          show: true,
          template: 'base-carousel-indicators'
        }
      }
    }).init();

    // Countdown to event date
    pes.extend(pes.countdown, {
      view: "#countdown",
      options: {
        // GMT-0700 = Mountain Time, 00:00 = midnight, 13:00 = 1pm
        endtime: "22 June 2018 00:00 GMT-0700"
      }
    }).init();

    // Gallery example
    pes.extend(pes.gallery, {
        src: '#model-gallery-example',
        view: '#gallery-example',
        options: {
          // Add a cooler gallery for my site
          // template: 'my-gallery'
        }
      }
    ).init();

    // Products list
    pes.extend(pes.product, {
        // Feed URL from inMotion hosting for the a2z exhibitor list
        // * Add the a2z Event ID to return all exhibitors for an event
        // * PESAPP.product callback filters the result to companies with products only
        url: '//pentonweb.com/api/a2z/2016/ExhibitorProvider.php?id=644',
        view: '#product-list',
        controller: '#product-list-controller'
      }
    ).init();

    // RSS feed
    pes.extend(pes.rssFeed, {
      // RSS feed from a Piscese website
      // New configuration does not rely on YQL
      url: '//pentonweb.com/api/v2/rss/?&cdata=1&url=https://mro-network.com/mro-rss',
      view: '#rss-feed',
        options: {
          // If you only want to return three items
          limitTo: 3,
          alias: 'channel.item',
          ajax: {
            dataType: 'jsonp'
          },
          yql: {
            mode: false
          }
        }
      }
    ).init();

    pes.extend(pes.sponsorOpps, {
        view: '#sponsorship-opps',
        url: '//opps.pentonweb.com/category/expo-west-2017/?json=get_posts&post_type=opportunity&orderby=title&order=asc&count=-1&exclude=comments,comment_count,comment_status,author,date,modified,tags,url,status',
        controller: '#sponsor-opps-controller',
        options: {
          contact: {
            link: '#link' // Link to a contact page, or remove to hide link
          },
          inclusion: {
            link: '#link' // Link to an inclusions page, or remove to hide link
          },
          // Update below if using types
          // typeConfig: {
          //   propertyName: 'opp_type_ew'
          // },
          // Update below if using levels
          levelConfig: {
            propertyName: 'opp_level_ew',
            levels: {
              'Platinum': {
                sort: '1',
                class: 'bg-platinum'
              },
              'Gold': {
                sort: '2',
                class: 'bg-gold'
              },
              'Silver': {
                sort: '3',
                class: 'bg-silver'
              },
              'Marketing': {
                sort: '4',
                class: 'bg-primary'
              }
            }
          }
        }
      }
    ).init();

    pes.extend(pes.exhibitor, {
      url: "//pentonweb.com/api/a2z/2016/ExhibitorProvider.php?id=653",
      view: "#exhibitor-list",
      controller: "#exhibitor-list-controller"
    }).init();

    pes.extend(pes.session, {
      url: "//pentonweb.com/api/a2z/2016/ConferenceProvider.php?id=653",
      view: "#session-list-mar-08",
      options: {
        dates: ["03/08/2017"]
      }
    }).init();
    pes.extend(pes.session, {
      url: "//pentonweb.com/api/a2z/2016/ConferenceProvider.php?id=653",
      view: "#session-list-mar-09",
      options: {
        dates: ["03/09/2017"]
      }
    }).init();
    pes.extend(pes.session, {
      url: "//pentonweb.com/api/a2z/2016/ConferenceProvider.php?id=653",
      view: "#session-list-mar-10",
      options: {
        dates: ["03/10/2017"]
      }
    }).init();

    // Sponsor carousel for a2z session pages
    pes.extend(pes.sessionSponsor, {
      // Club Industry Show 2017 sponsor data
      url: "//sponsortool.penton.com/json/1526541",
      // Following class should be added to SessionDetails_ID.xslt, Sessions_Summary_ID.xslt
      view: ".session-sponsor-carousel",
      options: {
        /* Default options as follows: */
        //   template: "session-sponsor-carousel",
        //   logosPerSlide: 1,
        //   logoLinks: false,
        //   sorts: "randomize",
        //   sizeClass: "gold",
        // Configure levels
        "1": {
          "heading": "Sponsored By"
        },
        "2": {
          "heading": "Hosted By"
        }
      }
    }).init();

    // Exhibitor sponsor logos
    pes.extend(pes.sessionSponsor, {
      // Should be same URL as used in main sponsor list
      url: "https://sponsortool.penton.com/json/1570727",
      // Following class should be added to SessionDetails_ID.xslt, Sessions_Summary_ID.xslt
      view: ".exhibitor-sponsor-logo",
      options: {
        /* Default options as follows: */
        //   template: "session-sponsor-carousel",
        //   logosPerSlide: 1,
        //   logoLinks: false,
        //   sorts: "randomize",
        sizeClass: "silver",
        "1": {
          "heading": ""
        },
        "2": {
          "heading": ""
        },
        "3": {
          "heading": ""
        },
        "4": {
          "heading": ""
        }
      }
    }).init();

    // BONUS: An example sub-module
    // See src/js/components/my-example.js and src/js/templates/my-example.html
    // pes.extend(pes.myExample).init();

  });
}(PESAPP, jQuery));
